<template>
  <div :class="['site-shell', { 'admin-shell': isAdmin }]">
    <template v-if="!isAdmin">
      <header class="site-header">
        <router-link class="wordmark" to="/" aria-label="TRAOUT 首页">TRA<span>O</span>UT<i>®</i></router-link>
        <button class="menu-toggle" aria-label="打开导航" @click="menuOpen = !menuOpen">{{ menuOpen ? '收起' : '菜单' }} <b>＋</b></button>
        <nav :class="['main-nav', { 'is-open': menuOpen }]" aria-label="主导航">
          <div v-for="item in topLevelNav" :key="item.id" class="nav-entry" @mouseenter="activeMenu = item.id" @mouseleave="activeMenu = null">
            <a v-if="item.external" :href="item.target" target="_blank" rel="noopener noreferrer">{{ item.label }}<span v-if="childrenOf(item.id).length" class="nav-caret">⌄</span></a>
            <router-link v-else :to="navigationTarget(item)"><span>{{ item.label }}</span><span v-if="childrenOf(item.id).length" class="nav-caret">⌄</span></router-link>
            <div v-if="childrenOf(item.id).length" v-show="activeMenu === item.id || menuOpen" class="nav-dropdown">
              <template v-for="child in childrenOf(item.id)">
                <a v-if="child.external" :key="child.id" :href="child.target" target="_blank" rel="noopener noreferrer">{{ child.label }} ↗</a>
                <router-link v-else :key="`internal-${child.id}`" :to="navigationTarget(child)">{{ child.label }}</router-link>
              </template>
            </div>
          </div>
          <form class="nav-search" @submit.prevent="searchProducts"><input v-model="searchText" aria-label="搜索产品" placeholder="搜索" /><button aria-label="提交搜索">↗</button></form>
        </nav>
      </header>
      <main><router-view :search-query="activeSearch" /></main>
      <footer class="site-footer">
        <div class="footer-mark">TRAOUT<span>®</span></div>
        <p>{{ footerContent.body || '心之所向，步之所致。内外探索，遨游无疆。' }}</p>
        <div class="footer-detail"><strong>{{ footerContent.title || '来访 / 联系' }}</strong><span>{{ storeAddress }}</span><span>营业时间 09:30—21:30 · 全周营业</span><a :href="`mailto:${footerEmail}`">{{ footerEmail }}</a></div>
        <div class="footer-end"><span>© TRAOUT 户外生活方式</span><router-link to="/admin">运营后台 ↗</router-link></div>
      </footer>
    </template>
    <router-view v-else />
  </div>
</template>

<script>
import { getPortal } from './api'

export default {
  data: () => ({ navigation: [], contents: [], searchText: '', activeSearch: '', menuOpen: false, activeMenu: null }),
  computed: {
    isAdmin() { return this.$route.name === 'admin' },
    topLevelNav() { return this.navigation.filter(item => !item.parentId) },
    footerContent() { return this.contents.find(item => item.contentKey === 'footer.info') || {} },
    storeContent() { return this.contents.find(item => item.contentKey === 'store.info') || {} },
    storeAddress() { return (this.storeContent.body || '广东省东莞市南城街道白马先锋二路1号101室').split(/\r?\n/)[0] },
    footerEmail() { const match = (this.footerContent.body || '').match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i); return match ? match[0] : 'support@traout.com' }
  },
  watch: {
    '$route.path'() { this.menuOpen = false }
  },
  created() { this.loadNavigation() },
  methods: {
    async loadNavigation() {
      try { const data = await getPortal(); this.navigation = data.navigation || []; this.contents = data.contents || [] } catch (error) { this.navigation = []; this.contents = [] }
    },
    childrenOf(id) { return this.navigation.filter(item => Number(item.parentId) === Number(id)) },
    navigationTarget(item) { return item.target || (item.label.trim() === '线上商城' ? '/mall' : '/') },
    searchProducts() {
      this.activeSearch = this.searchText.trim()
      if (this.$route.path !== '/products') this.$router.push('/products')
    }
  }
}
</script>